<template>
  <div class='footer'>
      <div class="containers" v-if="windowWidth<=1200">
          <el-row style="margin:0 auto;">
              <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" >
                <div class="img_list_box">
                    <a class="alink_box" target="_blank" href="https://eservices.mas.gov.sg/fid/institution/detail/242143-CYBERDYNE-TECH-EXCHANGE-PTE-LTD">
                      <img src='../../assets/img/footer-logo.png' style="width:100%;height:100%" />
                    </a>
                    <label class="dist_box" style="color:#696969;margin-top: 15px;margin-left:10px">License no. CMS 101073<br>Recognised Market Operator</label>
                </div>
                <!-- <el-divider></el-divider> -->
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" style="margin-bottom:10px;">
                  <div class="footer-nav">
                        <a style='color:#FFFFFF;text-decoration:none' href="#"> 
                             Email: <a  href="mailto:contact@mvgx.com" style="color:#FFFFFF;text-decoration:none">contact@mvgx.com</a><br>
                            75 Ayer Rajah Crescent #02-15 Singapore 139953</a>
                    </div>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                  <div class="copyright-txt dist_box">
                    Copyright &copy; 2018 - 2021 Cyberdyne Tech Exchange Pte. Ltd. All rights reserved.
                  </div>
              </el-col>
              
          </el-row>
      </div>

      <div class="containers" v-if="windowWidth>1200">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                <div class="footer-nav-t">
                    <a style='text-decoration:none' href="#"> 
                                                Email: <a href="mailto:contact@mvgx.com" style="color:#FFFFFF;text-decoration:none">contact@mvgx.com</a><br>
                        <!-- <el-divider style="width:100%;margin:10px auto"></el-divider> -->
                        75 Ayer Rajah Crescent #02-15<br> Singapore 139953</a>
                </div>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" style="text-align:center;padding-top:10px">
              <div class="img_list_box_t">
                  <a class="alink_box" target="_blank" href="https://eservices.mas.gov.sg/fid/institution/detail/242143-CYBERDYNE-TECH-EXCHANGE-PTE-LTD">
                    <img src='../../assets/img/footer-logo.png' style="width:85%" />
                  </a>
                  
              </div>
              <label class="dist_box_t">License no. CMS 101073<br>Recognised Market Operator</label>
            </el-col>
              
            <el-col style='text-align:right' :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                <div class="copyright-txt-t">
                  Copyright &copy; 2018 - 2021<br>  Cyberdyne Tech Exchange Pte. Ltd.<br> All rights reserved.
                </div>
            </el-col>
              
          </el-row>
      </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  props: {
    widthmun: {
      type: Number,
    }
  },
  components: {},
  data () {
  // 这里存放数据
    return {
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      ani:0
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
      windowHeight (val) {
        let that = this;
        
      },
      widthmun (val) {
        let that = this;
        that.windowWidth = val;
        console.log('宽111',val)
      }
  },
  // 方法集合
  methods: {
    // showIcon() {
    //   if (!!document.documentElement.scrollTop && document.documentElement.scrollTop > 800) {            
    //       console.log(1,document.documentElement.scrollTop)
    //       this.ani = 1
    //     } else {
    //       console.log(2,document.documentElement.scrollTop)
    //       this.ani = 0
    //     }
    // },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
      // <!--把window.onresize事件挂在到mounted函数上-->
      // window.addEventListener("scroll", this.showIcon);
      var that = this;
        window.onresize = () => {
            return (() => {
              window.fullHeight = document.documentElement.clientHeight;
              window.fullWidth = document.documentElement.clientWidth;
              that.windowHeight = window.fullHeight;  // 高
              that.windowWidth = window.fullWidth; // 宽
            })()
          };
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
@import '../../assets/css/footer.scss';
</style>
